export const API_KEYS = {
  RECAPTCHA_SITE_KEY: '6LcdMGYaAAAAAEZ8W9lB809zBFYzX1di1HKbJsLj', // Client's
};

export const PAGE_TITLES = {
  LOGIN: ' - Login',
  CUSTOMER_SUPPORT_LOGIN: ' - Customer Support Login',
  FORGOT_USERNAME: ' - Forgot Username',
  FORGOT_PASSWORD: ' - Forgot Password',
  RESET_PASSWORD: ' - Reset Password',
  HOME: ' - My Account Home',
  PROFILE: ' - Profile',
  PAYMENT_CENTER: ' - Payment Center',
  PAY_NOW: ' - Pay Now',
  PAYMENT_METHODS: ' - Payment Methods',
  PRODUCT_SUMMARY: ' - Product Summary',
  PRODUCT_DETAILS: ' - Product Details',
  REGISTRATION_IDENTIFICATION: ' - Registration: Identification Information',
  REGISTRATION_PERSONAL: ' - Registration: Personal Information',
  REGISTRATION_LOGIN: ' - Registration: Login Information',
  UNSUBSCRIBE_EMAILS: ' - Unsubscribe Emails',
};

export const PAGES_TITLE_KEYS = {
  LOGIN: 'login',
  CUSTOMER_SUPPORT_LOGIN: 'cs-login',
  FORGOT_USERNAME: 'forgot-username',
  FORGOT_PASSWORD: 'forgot-password',
  RESET_PASSWORD: 'reset-password',
  HOME: 'dashboard',
  PROFILE: 'my-profile',
  PAYMENT_CENTER: 'products',
  PAY_NOW: 'pay-now',
  PAYMENT_METHODS: 'payment-methods',
  PRODUCT_SUMMARY: 'products-main',
  PRODUCT_DETAILS: 'product-details',
  REGISTRATION_IDENTIFICATION: 'account-details',
  REGISTRATION_PERSONAL: 'personal-info',
  REGISTRATION_LOGIN: 'sign-in-creds',
  UNSUBSCRIBE_EMAILS: 'unsubscribe',
  REACTIVATE_USER: 'reactivate-account',
};

export const ARTICLES = {
  HEADER_PHONE_INFO: 'login-header-phone',
  LOGIN_FORM_REG_INFO: 'login-form-reg-info',
  CHANGE_PASSWORD_TOP_INFO: 'change-password-top-info',
  CHANGE_PASSWORD_BOTTOM_INFO: 'change-password-bottom-info',
  PRODUCT_DISCLAIMER: 'payment-center-landing-asterisk-content',
  PRODUCTS_NO_RADIO: 'pay-now-no-radio-button-selected-tool-tip-content',
  PAYNOW_RADIO_GHP_TOOLTIP: 'pay-now-radio-button-selected-tool-tip-content-ghp',
  PRODUCTS_AUTO_TOOLTIP: 'pay-now-auto-pay-tool-tip-content',
  REG_ACCOUNT_DETAILS_NOTE: 'registration-step-1-content',
  FORGOT_PASSWORD_INFO: 'reset-password-form-content',
  FORGOT_USERNAME_FORM_INFO: 'forgot-username-form-content',
  CONFIRM_DELETE_PAYMENT_METHOD: 'delete-payment-method-confirm-body',
  REMOVE_AUTOPAY_CONFIRM: 'remove-autopay-confirm',
  CERTI_NUM_INFO: 'certificate-num-info',
  PRODUCT_DISCLAIMER_COMBINED_BILLING: 'product-disclaimer-combinedbilling',
  PRODUCT_DISCLAIMER_NOCOST: 'product-disclaimer-nocost',
  CONTACT_US: 'contact-us',
  ABOUT_US: 'about-us',
  PRODUCT_DETAILS_BENEFITS: 'product-details-benefits',
  PRODUCT_DETAILS_MISMATCH_DATA: 'product-details-mismatch-info',
  TERMS_OF_SERVICE: 'terms-of-service',
  PRIVACY_POLICY: 'privacy-policy',
  CLAIM_NOW: 'claim-now',
  AUTOPAY_INSURANCE: 'autopay-insurance-confirm',
  AUTOPAY_INSURANCE_NOBILL: 'autopay-insurance-no-bill-confirm',
  AUTOPAY_NON_INSURANCE: 'autopay-noninsurance-confirm',
  PAYNOW_INSURANCE: 'paynow-insurance-confirm',
  PAYNOW_INSURANCE_NOBILL: 'paynow-insurance-no-bill-confirm',
  PAYNOW_INSURANCE_NOBILL_GHP: 'paynow-insurance-no-bill-confirm-ghp',
  PAYNOW_NON_INSURANCE: 'paynow-noninsurance-confirm',
  FREQUENCY_UPDATED: 'frequency-updated-confirm',
  FREQUENCY_UPDATED_NOBILL: 'frequency-updated-no-bill-confirm',
  SITE_DISCLAIMER: 'site-disclaimer',
  REGEX_VS: 'regex-visa',
  REGEX_MC: 'regex-mastercard',
  REGEX_DS: 'regex-discover',
  REGEX_AM: 'regex-amex',
  EA_MEMBERS_NOTE: 'ea-members-note',
  MYACCOUNT_WELCOME: 'myaccount-welcome',
  AUTOPAY_MARKETTING: 'autopay-content',
  MYPROFILE_TIP: 'profile-content',
  ANNUAL_PRODUCT_COST_DISCLAIMER: 'annual-product-cost-disclaimer',
  HEADER_TAGS: 'custom-head-tags',
  CUSTOM_SCRIPTS_BODY_START: 'custom-scripts-body-start',
  CUSTOM_SCRIPTS_BODY_END: 'custom-scripts-body-end',
  DOCUMENT_ERROR: 'document-error',
  TRANSACTION_DISCLAIMER: 'transactions-disclaimer-content',
  TOOLTIP_DUE_FREQUENCY: 'tooltip-due-frequency',
  TOOLTIP_FREQUENCY_NO_SELECTION: 'upadate-frequency-tooltip-content',
  PAGES_TITLE: 'pages-title',
  EA_PLUS_MEMBER_NOTE: 'ea-plus-member-note',
};

export const NOTIFICATIONS = {
  PLAN_NUM_NUMERIC: 'Your Certificate/Plan Number should be numeric.',
  PLAN_NUM_10_LEN: 'Your Certificate/Plan Number should be 10 digits long.',
  INVALID_EMAIL_FORMAT: 'The email address you have entered is not valid.',
  PLAN_NUMBER_NOT_FOUND:
    'The Certificate or Plan Number you entered could not be validated. Your Plan Number is a 10 digit number which can be found on your plan documentation or on a bill.',
  BOT_SUSPECTED: 'You behaviour verified as a bot. Please refresh the page to try again.',
  INVALID_PHONE: 'Please enter a 10-digit phone number.',
  ACCOUNT_NUM_NOT_MATCH: 'Your account numbers do not match.',
  ROUTE_NUM_NOT_MATCH: 'Your routing numbers do not match.',
  CONNECTIVITY_ERROR:
    'Is seems as though we are not able to connect the server. Please try again or call our customer service team for support. ',
  INVALID_CREDIT_CARD:
    'Error. We were unable to update this payment option. Please check your account or card information and try again or enter an alternate form of payment.',
  REACTIVATE_USER_HEADER:
    'For security purposes, we need to reactivate your account. Please select a new username, password and security question below.',
  INVALID_LOCATION: '',
};

export const NOTIFICATIONS_TYPE = {
  SUCCESS: 'successAlert',
  FAILURE: 'warningAlert',
  INFO: 'infoAlert',
  ERROR: 'warningAlert',
  CLIENT_MISMATCH: 'warningAlert',
};

export const CARDS_TYPE = [
  { id: 'VS', name: 'VISA', regex_WC_key: ARTICLES.REGEX_VS },
  { id: 'MC', name: 'MasterCard', regex_WC_key: ARTICLES.REGEX_MC },
  { id: 'DS', name: 'Discover', regex_WC_key: ARTICLES.REGEX_DS },
  { id: 'AM', name: 'Amex', regex_WC_key: ARTICLES.REGEX_AM },
];

export const MONTHS = [
  { id: '01', name: 'Jan' },
  { id: '02', name: 'Feb' },
  { id: '03', name: 'Mar' },
  { id: '04', name: 'Apr' },
  { id: '05', name: 'May' },
  { id: '06', name: 'Jun' },
  { id: '07', name: 'Jul' },
  { id: '08', name: 'Aug' },
  { id: '09', name: 'Sep' },
  { id: '10', name: 'Oct' },
  { id: '11', name: 'Nov' },
  { id: '12', name: 'Dec' },
];

export const MONTHS_LONG = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const VIEW_DOC_LOADER_HTML_STR = `<div style="
height: 100%;
display: flex;
align-items: center;
justify-content: center;
">
<img style="width: 5vh" src="data:image/gif;base64,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"></div>`;
